import { render, staticRenderFns } from "./KkmServerUnitsInfo.vue?vue&type=template&id=33b8e73b&scoped=true&"
import script from "./KkmServerUnitsInfo.vue?vue&type=script&lang=js&"
export * from "./KkmServerUnitsInfo.vue?vue&type=script&lang=js&"
import style0 from "./KkmServerUnitsInfo.vue?vue&type=style&index=0&id=33b8e73b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8e73b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VProgressCircular,VSimpleTable})
